import Good from '../model/good';

export const stringifySpecification = function (goods: Good[]): string {
    return goods.map(good => good.name).join(', ');
};
